import {
  AUTH_USER,
  CLEAN_AUTH,
  AUTH_ERROR,
  VIEW_AS_STUDENT,
  CLEAR_VIEW_AS_STUDENT,
  FETCH_WORD_LEVEL_PROGRESS,
  LEVEL_UNLOCKED,
  FETCH_UNIT_LEVEL_PROGRESS,
  UNIT_LEVEL_UNLOCKED
} from "../actions/type";

const INIT_STATE = { user: null, errorMessage: "", isLogin: false };

// See VIEW_AS_STUDENT below
const asStudent = (user) => ({
  ...user,
  viewAsStudent: true,
  realRole: user.role,
  realRoles: user.roles,
  role: "student",
  roles: ["student"]
});

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case AUTH_USER: {
      const user = {
        ...payload.user,
        roles: payload.user?.roles || []
      };
      // An in-place re-login of the same account during a teacher-run
      // 簡誼健檢 keeps the student presentation (no flash of the teacher
      // view between this and TeacherRoute re-applying it)
      const keepStudentView =
        state.user?.viewAsStudent === true &&
        state.user?.id !== undefined &&
        state.user.id === user.id;
      return {
        ...state,
        user: keepStudentView ? asStudent(user) : user,
        isLogin: true,
        errorMessage: ""
      };
    }
    case CLEAN_AUTH:
      return { ...INIT_STATE };
    // A teacher running the 簡誼健檢 for a student without an account: the
    // page host, the templates and the teaching-notes panel all branch on
    // `role` / `roles`, so while the student holds the device the user is
    // presented as a student. Identity (id, username, name) is untouched —
    // the record is still submitted by the teacher. The real roles stay in
    // `realRoles` for route authorization (a student may not enter
    // /teacher). AUTH_USER for the same account keeps it (see above);
    // TeacherRoute clears it when the run URL is left or it unmounts.
    case VIEW_AS_STUDENT:
      if (!state.user || state.user.viewAsStudent) return state;
      return { ...state, user: asStudent(state.user) };
    case CLEAR_VIEW_AS_STUDENT: {
      if (!state.user || !state.user.viewAsStudent) return state;
      const { viewAsStudent, realRole, realRoles, ...user } = state.user;
      return {
        ...state,
        user: { ...user, role: realRole, roles: realRoles || [] }
      };
    }
    case AUTH_ERROR:
      return { ...state, errorMessage: payload };
    case FETCH_WORD_LEVEL_PROGRESS:
      return {
        ...state,
        user: {
          ...state.user,
          wordLevelProgress: payload
        }
      };
    case LEVEL_UNLOCKED:
      return {
        ...state,
        user: {
          ...state.user,
          wordLevelProgress: {
            ...(state.user?.wordLevelProgress || {}),
            [payload.booksetId]: payload.newMaxLevel
          }
        }
      };
    case FETCH_UNIT_LEVEL_PROGRESS:
      return {
        ...state,
        user: {
          ...state.user,
          unitLevelProgress: payload
        }
      };
    case UNIT_LEVEL_UNLOCKED:
      return {
        ...state,
        user: {
          ...state.user,
          unitLevelProgress: {
            ...(state.user?.unitLevelProgress || {}),
            [payload.bookId]: payload.newMaxUnitLevel
          }
        }
      };
    default:
      return state;
  }
};
